import {
  Swords,
  Briefcase,
  Dices,
  Stethoscope,
  FileText,
  BookOpenText,
  LayoutDashboard,
  History,
  SlidersHorizontal,
  Settings,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  /** Short description shown on the Home hub cards. */
  blurb: string;
  /** Marks the three core "pillar" destinations highlighted on Home. */
  pillar?: boolean;
}

/**
 * Single source of truth for the app's primary navigation. The sidebar,
 * the Home hub, and the router all read from this list.
 */
export const NAV_ITEMS: NavItem[] = [
  {
    path: "/challenge",
    label: "Design Challenge",
    icon: Swords,
    blurb: "Get a random real-world game-design challenge to solve.",
    pillar: true,
  },
  {
    path: "/interview",
    label: "Interview Prep",
    icon: Briefcase,
    blurb: "Practice real game-design interview questions & exercises.",
    pillar: true,
  },
  {
    path: "/jam",
    label: "Game-Jam Ideas",
    icon: Dices,
    blurb: "Roll a random concept: theme + genre + mechanic + twist.",
    pillar: true,
  },
  {
    path: "/triage",
    label: "Triage",
    icon: Stethoscope,
    blurb: "Interrogate a mechanic, system, or feature to find its gaps.",
    pillar: true,
  },
  {
    path: "/docs",
    label: "Design Docs",
    icon: FileText,
    blurb: "Build real design docs — one-sheet, pitch, or full GDD.",
  },
  {
    path: "/library",
    label: "Study Library",
    icon: BookOpenText,
    blurb: "Your compiled digital book of all game-design knowledge.",
  },
  {
    path: "/dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    blurb: "Track XP, streaks, mastery, and progress over time.",
  },
  {
    path: "/history",
    label: "History",
    icon: History,
    blurb: "Revisit every challenge and interview answer you've saved.",
  },
  {
    path: "/customize",
    label: "Customize",
    icon: SlidersHorizontal,
    blurb: "Add your own disciplines, concepts, challenges, and questions.",
  },
  {
    path: "/settings",
    label: "Settings",
    icon: Settings,
    blurb: "Theme, AI, and sync preferences.",
  },
];
